import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-addgs",
  "use": "icon-addgs-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-addgs\">\r\n  <defs>\r\n    <style>\r\n      #icon-addgs .cls-1 {\r\n        fill: #40a9ff;\r\n      }\r\n\r\n      #icon-addgs .cls-2 {\r\n        font-size: 24px;\r\n        fill: #fff;\r\n        text-anchor: middle;\r\n        font-family: Arial;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <circle id=\"icon-addgs_椭圆_3\" data-name=\"椭圆 3\" class=\"cls-1\" cx=\"14\" cy=\"14\" r=\"14\" />\r\n  <text id=\"icon-addgs__\" data-name=\"+\" class=\"cls-2\" x=\"14.269\" y=\"22.658\">+</text>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/addgs.svg
// module id = Y95a
// module chunks = 127